import AxiosService from './AxiosService'

class PermissionRestService {
  get(): Promise<any> {
    return AxiosService.get('/permissions')
  }
}

export default new PermissionRestService()
